export default __webpack_public_path__ + "static/media/deliveries.1aabf8c6.svg";